import { DialogActions, DialogTitle } from '@mui/material';
import { MemberCampaign } from '@retail/campaign/types';
import React from 'react';
import { useAppTFunction } from '@retail/app/i18n';
import { ContainedButton, Dialog, TextButton } from '@shared/components';

interface Props {
  campaign: MemberCampaign;
  onLeave: () => void;
  onClose: () => void;
  open: boolean;
  isLoading: boolean;
}

export const LeaveCentralCampaignDialog = ({
  campaign,
  onLeave,
  onClose,
  open,
  isLoading,
}: Props) => {
  const t = useAppTFunction();
  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>{`${t('campaign.actions.leaveCampaign')}: ${campaign.name}`}</DialogTitle>

      <DialogActions>
        <TextButton onClick={onClose} size="small">
          {t('common.cancel')}
        </TextButton>

        <ContainedButton loading={isLoading} onClick={onLeave} size="small">
          {t('campaign.actions.leaveCampaign')}
        </ContainedButton>
      </DialogActions>
    </Dialog>
  );
};
